import { forwardRef } from 'react';
import type React from 'react';

type OwnProps = React.SVGProps<SVGSVGElement> & {
  fill?: string;
};

const Magnify = forwardRef<SVGSVGElement, OwnProps>((props, ref) => (
  <svg viewBox="0 0 16 16" ref={ref} {...props}>
    <path
      d="M15.75 14.57l-3.86-3.86A6.64 6.64 0 0 0 6.64 0 6.66 6.66 0 0 0 0 6.64a6.64 6.64 0 0 0 6.64 6.64 6.57 6.57 0 0 0 4.07-1.39l3.86 3.87a.87.87 0 0 0 .59.24.83.83 0 0 0 .59-1.43zM6.64 1.67a5 5 0 0 1 3.52 1.46 5 5 0 0 1-3.52 8.48 4.9 4.9 0 0 1-3.51-1.45 5 5 0 0 1 3.51-8.49z"
      fill={props.fill || 'currentColor'}
    />
  </svg>
));

export default Magnify;
